<template>
  <v-app class="theme--dark">
    <navbar />

    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center> </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  components: {
    navbar: () => import('../components/Navbar.vue'),
  },
  props: {
    source: String,
  },
}
</script>
